module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "fanyi"
    },
    slot: "fanyi"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.beforeTxt),
      expression: "model.beforeTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "请输入转换前字符串... 粘贴/空格后自动翻译"
    },
    domProps: {
      "value": (_vm.model.beforeTxt)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32, $event.key, " ")) { return null; }
        return _vm.fanyi($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 86) { return null; }
        if (!$event.ctrlKey) { return null; }
        return _vm.fanyi($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "beforeTxt", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.typeOptions
    },
    on: {
      "change": _vm.fanyi
    },
    model: {
      value: (_vm.currentOption),
      callback: function($$v) {
        _vm.currentOption = $$v
      },
      expression: "currentOption"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.afterTxt),
      expression: "model.afterTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "rows": "13",
      "placeholder": "翻译结果..."
    },
    domProps: {
      "value": (_vm.model.afterTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "afterTxt", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [(_vm.model.jsonData) ? _c('pre', {
    staticClass: "layui-code",
    domProps: {
      "innerHTML": _vm._s(_vm.model.jsonData)
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b30a31f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fanyi.vue
// module id = 609
// module chunks = 2